<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (measurementLabel() || product()?.status?.selectedColor?.extraInfo?.fitSizeMessage?.text) {
    <div class="col-xs-12 text-center">
        <div class="text-center">
            @if (measurementLabel()) {
                <span class="text-m c-dark-grey">
                    {{ measurementLabel() | translate: { $0: measurement().modelSize, $1: measurement().modelHeigh } }}
                </span>
            }
            @if (product()?.status?.selectedColor?.extraInfo?.fitSizeMessage?.text) {
                <div class="row" [class.mb-20]="measurementLabel()">
                    <div class="col-xs-12 is-flex content-center">
                        <span class="text-m c-dark-grey">{{ product()?.status?.selectedColor?.extraInfo?.fitSizeMessage?.text }}</span>
                    </div>
                </div>
            }
        </div>
    </div>
}
